<template>
    <div id="app">

        <navbar></navbar>

        <side-menu></side-menu>

        <main>
            <section class="is-title-bar border-b-0">
                <div class="flex flex-col md:flex-row items-center justify-between space-y-6 md:space-y-0">
                    <ul>
                        <li class="title-stack-item inline-block pr-3 text-2xl text-gray-500 dark:text-white last:pr-0 last:font- last:text-black dark:!text-white-100">
                            <svg viewBox="0 0 24 24" width="16" height="16" class="inline-block">
                                <path fill="currentColor"
                                      d="M21,14H3V4H21M21,2H3C1.89,2 1,2.89 1,4V16A2,2 0 0,0 3,18H10L8,21V22H16V21L14,18H21A2,2 0 0,0 23,16V4C23,2.89 22.1,2 21,2Z"></path>
                            </svg>
                        </li>
                        <li class="title-stack-item inline-block pr-3 text-2xl text-gray-500 dark:text-white last:pr-0 last:font- dark:!text-white-100">
                            {{ title }}
                        </li>
                        <li class="title-stack-item inline-block pr-3 text-2xl text-gray-500 dark:text-white last:pr-0 last:font-black dark:!text-white-100"
                            v-for="nav in navs">{{ nav.title }}
                        </li>
                    </ul>

                </div>
            </section>
            <section
                class="border-gray-100 bg-white border-t border-b p-6 dark:bg-gray-900/70 dark:border-gray-900 dark:text-white">
                <div class="flex justify-between items-center block md:flex">
                    <div class="flex shrink-0 grow-0 items-center justify-center mb-6 md:mb-0"><h1
                        class="text-3xl font-semibold leading-tight">
                        {{ navs && navs.length > 0 ? navs[navs.length - 1].title : title }}</h1></div>
                    <div class="flex shrink-0 grow-0 items-center justify-center">
                        <new-campaign v-if="create === 'campaign'"></new-campaign>
                        <new-referrer v-if="create === 'referrer'"></new-referrer>
                        <slot name="action"></slot>
                    </div>
                </div>
            </section>
            <section class="section main-section mb-6">
                <slot></slot>
            </section>
        </main>

        <footer class="bg-white py-2 px-6 dark:bg-gray-900" style="
        display: flex;
    position: fixed;
    bottom: 0;
    width: 100%;
">
            <div class="flex flex-col md:flex-row items-center justify-between space-y-3 md:space-y-0">
                <div class="flex items-center justify-start space-x-3">
                    <div>
                        © Referex | <a href="https://sdaas.vihlix.com" class="text-blue-500"> Powered by Vihlix-SDaaS </a>
                    </div>
                </div>
            </div>
        </footer>

    </div>
</template>

<script>
import SideMenu from "@/Components/SideMenu";
import Navbar from "@/Components/Navbar";
import NewCampaign from "@/Components/NewCampaign";
import NewReferrer from "@/Components/NewReferrer";

export default {
    name: 'BackendLayout',
    props: {
        title: String,
        create: String,
        navs: Array
    },
    components: {
        NewReferrer,
        NewCampaign,
        Navbar,
        SideMenu
    },
}
</script>
